{
  "version": 1,
  "asset_id": "8f97725c-0133-4cde-b197-fcae6de02217",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/8f97725c-0133-4cde-b197-fcae6de02217/lynx-gsc-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/8f97725c-0133-4cde-b197-fcae6de02217/lynx-gsc-1280.webp",
  "original_filename": "lynx-gsc-1280.webp",
  "size": 57368,
  "content_type": "image/webp",
  "created_at": "2026-08-02T02:39:02Z"
}
